import React from "react";
import "./OccupationType.css";
import RedRoundBtn from "../../../Common_Btn/RedRoundBtn/RedRoundBtn";
import { logDOM } from "@testing-library/react";

const OccupationType = (props) => {
  const handleClick = async (data) => {
    // Ensure setOccupation exists before calling it
    // if (props.setOccupation) {
    await props.setOccupation(data);
    // }
    console.log(data, "data data");

    // Move to next step if handleNext is available
    props?.handleNext?.();
  };
  console.log(props.occupation === "Salaried", "props.occupation");

  return (
    <section className="OccupationType">
      <p className="step_title">Please choose your occupation type</p>

      <div className="type_holder_div">
        <div className="row">
          <div className="col-6">
            <div className="type_card_holder">
              <div className="img_holder">
                <img
                  src="\assets\Image\term_lifeinsuarnce\occup1.png"
                  className="occup_img"
                />
              </div>
              <div className="occup_btn_holder">
                <RedRoundBtn
                  btn_name="Salaried"
                  selected={props.occupation === "Salaried"}
                  onClick={() => {
                    handleClick("Salaried");
                  }}
                />
              </div>
            </div>
          </div>

          <div className="col-6">
            <div className="type_card_holder">
              <div className="img_holder">
                <img
                  src="\assets\Image\term_lifeinsuarnce\occup2.png"
                  className="occup_img"
                />
              </div>
              <div className="occup_btn_holder">
                <RedRoundBtn
                  btn_name="Self Employeed"
                  selected={props.occupation === "Self Employeed"}
                  onClick={() => {
                    handleClick("Self Employeed");
                  }}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default OccupationType;
